import {
    GET_USERS,
    SET_USERS,
    GET_USER_BRANCHES,
    SET_USER_BRANCHES,
    SAVE_ASSET_INVENTORY_USER_BRANCHES,
    SAVE_USER_BRANCH_SUCCESS,
    GET_USER_EQUIPEMENT_ORDERER_ROLE,
    GET_USERS_BY_EMP_ID,
    SAVE_USER_PROFILE_BRANCHES,
    SAVE_USER_PROFILE_PERSONAL_INFO,
    SAVE_USER_PROFILE_NOTIFICATION_SUBSCRIPTION,
    UPLOAD_USER_PROFILE_IMAGE,
    SET_USER_PROFILE_IMAGE
} from './UserProfileTypes'

const getUsers = (searchString: string) => {
    return {
        type: GET_USERS,
        searchString
    }
}
const setUsers = (users: any) => {
    return {
        type: SET_USERS,
        users
    }
}

const getUserBranches = (emailId : any) => {
    return {
        type: GET_USER_BRANCHES,
        emailId
    }
}

const setUserBranches = (branches: any) => {
    return {
        type: SET_USER_BRANCHES,
        branches
    }
}

const saveAssetInventoryUserBranches = (payload: any) => {
    return {
        type: SAVE_ASSET_INVENTORY_USER_BRANCHES,
        payload
    }
}

const saveUserBranchSuccess = (flag: any) => {
    return {
        type: SAVE_USER_BRANCH_SUCCESS,
        flag
    }
}
const getUserEquipmentOrdererRole = (emailId: any) => {
    return {
        type: GET_USER_EQUIPEMENT_ORDERER_ROLE,
        emailId
    }
}

const getUsersByEmpId = (searchId: string) => {
    return {
        type: GET_USERS_BY_EMP_ID,
        searchId
    }
}

const saveUserProfilePersonalInfo = (payload: any) => {
    return {
        type: SAVE_USER_PROFILE_PERSONAL_INFO,
        payload
    }
}

const saveUserProfileBranches = (payload: any) => {
    return {
        type: SAVE_USER_PROFILE_BRANCHES,
        payload
    }
}

const saveUserProfileNotificationSubs = (payload: any) => {
    return {
        type: SAVE_USER_PROFILE_NOTIFICATION_SUBSCRIPTION,
        payload
    }
}

const UploadUserProfileImage = (payload: any) => {
    return {
        type: UPLOAD_USER_PROFILE_IMAGE,
        payload
    }
}
const setUserProfileImage = (response: any) => {
    return {
        type: SET_USER_PROFILE_IMAGE,
        response
    }
}

export {
    getUsers,
    setUsers,
    getUserBranches,
    setUserBranches,
    saveAssetInventoryUserBranches,
    saveUserBranchSuccess,
    getUserEquipmentOrdererRole,
    getUsersByEmpId,
    saveUserProfilePersonalInfo,
    saveUserProfileBranches,
    saveUserProfileNotificationSubs,
    UploadUserProfileImage,
    setUserProfileImage
}